import React, { useState } from "react";
import "../Shippers/ShippersList/shipperslist.css";

// components imports
import ShippersTable from "../../../../../Components/BoltTable/BoltTable";
import Confirm from "../../../../../Components/Popups/Confirm";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
import SwitchButton from "../../../../../Components/SwitchButton/SwitchButton";
// apis imports
import {
  fetchAllUsers,
  updateAccountStatus,
  deleteUserByAdmin,
} from "../../../../../services/AdminServices/Users/users.services";
// library imports
import { IoInformationCircleOutline } from "react-icons/io5";
import { IconButton } from "@mui/material";
import { convertTime } from "../../../../../helpers/helpers";
import LoginUserModel from "../LoginUser/LoginUser";
import { MdOutlineCancel } from "react-icons/md";
import { useTranslation } from "react-i18next";

const AllUserList = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [allUsers, setAllUsers] = useState([]);
  const [Change, setChange] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState();
  const [statusUpdating, setStatusUpdating] = useState();
  const [loginModal, setLoginModal] = useState(false);

  const GetAllUsers = async (page, perPage, filter) => {
    const response = await fetchAllUsers(page, perPage, filter);
    if (!response.error) {
      setAllUsers(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const ROLE_LABELS = {
    warehouseUser: t("users.roles.warehouseUser"),
    unVerifiedOneTimeShipper: t("users.roles.unVerifiedOneTimeShipper"),
    oneTimeShipper: t("users.roles.oneTimeShipper"),
  };

  const handleUserRole = (row) => {
    const role = row?.parent?.role || row?.role || "-";

    return ROLE_LABELS[role] || t(`users.roles.${role}`, { defaultValue: role });
  };

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("users.userName"),
      render: (row) => <>{row?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.businessName"),
      render: (row) => <>{row?.business_name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("users.userEmail"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("users.accountType"),
      render: (row) => (
        <>{row?.parent?.username ? t("users.helperUser") : t("users.mainAccount")}</>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("users.parentAccount"),
      render: (row) => (
        <>{row?.parent?.username ? row?.parent?.username : "-"}</>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("users.role"),
      render: (row) => <>{handleUserRole(row)}</>,
      width: "200px",
    },
    {
      id: 7,
      label: (
        <>
          {t("users.activate")}
          <Tooltip title={t("users.accountApprovedDisapproved")}>
            <IconButton>
              <IoInformationCircleOutline size={10} />
            </IconButton>
          </Tooltip>
        </>
      ),
      render: (row) => (
        <>
          <SwitchButton
            onChange={(e) => handleStatusChange(e, row)}
            checked={
              ![false, "false", "0", null, undefined].includes(
                row.account_status,
              )
            }
            disabled={Change === "Status" ? true : false}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 8,
      label: t("users.registeredAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 9,
      label: t("users.actions"),
      render: (row) => (
        <div className="table_action__wrap">
          <div
            className={`table_action__btn ${
              [false, "false", "0", null, undefined].includes(
                row.account_status,
              )
                ? "table_action__btn__disabled"
                : ""
            }`}
            onClick={() => setLoginModal(row)}
          >
            {t("users.login")}
          </div>
          {/* <Tooltip title="Reset Carrier Password">
                <div
                  className="table_action__btn"
                  onClick={() => setChangePassword(row.id)}
                >
                  <FaRegEdit size={10} />
                  RESET PASSWORD
                </div>
              </Tooltip> */}
          <Tooltip title={t("users.deleteCarrier")}>
            <div
              className="table_action__btn"
              onClick={(e) => setConfirmDelete(row)}
            >
              <MdOutlineCancel size={10} />
              {t("users.deleteButton")}
            </div>
          </Tooltip>
        </div>
      ),
      width: "250px",
      fixed: "right",
    },
  ];

  const handleStatusChange = async (e, record) => {
    setChange("Status");
    const updated = await updateAccountStatus({
      id: parseInt(record.id),
      account_status: e.target.checked,
    });

    if (updated.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: updated.error.message,
          severity: "error",
        };
      });
      setChange(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.account_status,
          )
            ? t("users.statusActive", { name: updated?.data?.result?.username ?? t("users.userFallback") })
            : t("users.statusInactive", { name: updated?.data?.result?.username ?? t("users.userFallback") }),
          severity: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.account_status,
          )
            ? "success"
            : "info",
        };
      });
      setAllUsers((prevOneTimeShippers) => {
        return {
          ...prevOneTimeShippers,
          data: prevOneTimeShippers?.data.map((item) =>
            item.id === record.id
              ? {
                  ...item,
                  account_status: ![
                    false,
                    "false",
                    "0",
                    null,
                    undefined,
                  ].includes(updated?.data?.result?.account_status),
                }
              : item,
          ),
        };
      });
      setChange(false);
    }
  };

  const handleDeleteUser = async (record) => {
    setStatusUpdating(true);
    const response = await deleteUserByAdmin(record.id);

    if (response.error) {
      setStatusUpdating(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    } else {
      setAllUsers((prevOneTimeShippers) => {
        return {
          ...prevOneTimeShippers,
          data: prevOneTimeShippers?.data.filter(
            (item) => item.id !== record.id,
          ),
        };
      });

      setStatusUpdating(false);
      setConfirmDelete(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("users.userDeletedSuccessfully"),
          severity: "success",
        };
      });
    }
  };

  return (
    <div>
      <LoginUserModel open={loginModal} setOpen={setLoginModal} />

      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteUser(confirmDelete)}
        text={t("users.doYouWantToDelete")}
        loader={statusUpdating}
      />
      <div>
        <div className="actionbtn__needtobe_fixwidth">
          <ShippersTable
            tableTitle={t("users.allUsersList")}
            tableId="allUserListTableForAdmin"
            message={t("users.noUsersAvailableToDisplay")}
            searchPlaceHolder={t("users.searchNotAvailable")}
            columns={columns}
            data={allUsers}
            getAllData={GetAllUsers}
          />
        </div>
      </div>
    </div>
  );
};

export default AllUserList;
